import { render } from "./S700_PraxisgruppeRechnungen.vue?vue&type=template&id=1b1f6d42&scoped=true&ts=true"
import script from "./S700_PraxisgruppeRechnungen.vue?vue&type=script&lang=ts"
export * from "./S700_PraxisgruppeRechnungen.vue?vue&type=script&lang=ts"

import "./S700_PraxisgruppeRechnungen.vue?vue&type=style&index=0&id=1b1f6d42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1f6d42"]])

export default __exports__